/**
 * Component Registry for Jackstraw Apartments
 * 
 * Inherits from @vibesites-repli-sandbox/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-repli-sandbox/theme-preferred/registry';
import { ScrollTextSection } from './components/ScrollTextSection';
import { FAQSection } from './components/FAQSection';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  ScrollTextSection,
  FAQSection,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
